import * as Sentry from '@sentry/react';
import { ApiErr } from './api';

type RuntimeConfig = { sentryDsn?: string };
const RUNTIME: RuntimeConfig = (window as unknown as { __VS_ADMIN__?: RuntimeConfig }).__VS_ADMIN__ ?? {};
const DSN: string = RUNTIME.sentryDsn || '';

const SECRET = /\b(?:vs_(?:key|kt|bt|rtmp|refresh)_[A-Za-z0-9_-]{8,}|eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+)/g;
const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const scrub = (s: string) => s.replace(SECRET, '[secret]').replace(EMAIL, '[email]');
const scrubUrl = (u: string) => scrub(u.replace(/[?#].*$/, ''));

export function initSentry() {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    release: (import.meta.env.VITE_GIT_SHA as string | undefined) || undefined,
    environment: 'production',
    initialScope: { tags: { app: 'admin' } },
    sendDefaultPii: false,
    integrations: [Sentry.breadcrumbsIntegration({ console: false })],
    beforeSend(event, hint) {
      if (hint.originalException instanceof ApiErr) return null;
      if (event.request?.url) event.request.url = scrubUrl(event.request.url);
      delete event.request?.headers;
      delete event.request?.cookies;
      delete event.request?.query_string;
      if (event.message) event.message = scrub(event.message);
      for (const ex of event.exception?.values ?? []) if (ex.value) ex.value = scrub(ex.value);
      return event;
    },
    beforeBreadcrumb(b) {
      for (const k of ['url', 'from', 'to']) if (typeof b.data?.[k] === 'string') b.data[k] = scrubUrl(b.data[k]);
      if (b.message) b.message = scrub(b.message);
      return b;
    },
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;

export function reportClientError(error: unknown) {
  if (error instanceof ApiErr) return;
  if ((error as { name?: string } | null)?.name === 'TypeError' && navigator.onLine === false) return;
  Sentry.captureException(error, { tags: { handled: 'shown' } });
}
